var map = {
	"./da/da.json": "5f5d",
	"./de/de.json": "e3d8",
	"./en/en.json": "8cad",
	"./es/es.json": "6184",
	"./fi/fi.json": "3078",
	"./fr/fr.json": "5f26",
	"./it/it.json": "bb39",
	"./nb/nb.json": "2065",
	"./nl/nl.json": "5a2d",
	"./pl/pl.json": "4091",
	"./pt/pt.json": "3b51",
	"./sv/sv.json": "e997"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "08c3";